import React, { useState } from 'react';
import { Drawer, DrawerContent, DrawerTrigger } from 'components/ui/drawer';
import { MoreHorizontal } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'components/ui/table';
import { UploadFile } from '../components';
import { Formatter } from 'utils/Formatter';

export type DataTableDrawersProps = {
  trigger?: React.ReactNode;
  table?: any;
  asChild?: boolean;
};

export const PendingStockDrawer: React.FC<DataTableDrawersProps> = ({
  trigger,
  table,
  asChild,
}) => {
  const [open, setOpen] = useState(false);

  const clearAndCloseDrawer = () => {
    table.toggleAllPageRowsSelected(false);
    setOpen(false);
  };

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild={asChild}>
        {trigger || <MoreHorizontal className="h-5 w-5 text-slate-500" />}
      </DrawerTrigger>
      <DrawerContent className="text-center">
        <>
          <div>
            <span
              className={`inline-block mb-4 bg-lime-600 text-slate-50 p-2 rounded text-xs font-bold`}
            >
              AG
            </span>
            <div className="w-[720px] m-auto mt-6 border-b borber-b-slate-600">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead className="w-[100px]">Código</TableHead>
                    <TableHead>Entrada</TableHead>
                    <TableHead>Fabricação</TableHead>
                    <TableHead>Vencimento</TableHead>
                    <TableHead>Valor</TableHead>
                    <TableHead className="text-right">Valor Total</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {table.getFilteredSelectedRowModel().rows.map((row: any) => (
                    <TableRow key={row.original.id}>
                      <TableCell className="font-medium">
                        {row.original.id}
                      </TableCell>
                      <TableCell>
                        {new Date(row.original.entranceDate).toLocaleDateString(
                          'pt-BR'
                        )}
                      </TableCell>
                      <TableCell>
                        {new Date(
                          row.original.manufacturingDate
                        ).toLocaleDateString('pt-BR')}
                      </TableCell>
                      <TableCell>
                        {new Date(
                          row.original.expirationDate
                        ).toLocaleDateString('pt-BR')}
                      </TableCell>
                      <TableCell>
                        {Formatter.currency(row.original.price)}
                      </TableCell>
                      <TableCell className="text-right">
                        {Formatter.currency(row.original.totalPrice)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>
          <div className="w-[720px] m-auto">
            <UploadFile
              ids={table
                .getFilteredSelectedRowModel()
                .rows.map((row: any) => row.original.id)}
              clearAndCloseDrawer={clearAndCloseDrawer}
            />
          </div>
        </>
      </DrawerContent>
    </Drawer>
  );
};
